/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface ChefEntrepriseSearchDto
 */
export interface ChefEntrepriseSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    nom?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    prenom?: UnaccentTextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    gsm?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    telephone?: TextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    siegeSocial?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    lieuFormation?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    enseigneLieuFormation?: UnaccentTextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    dateNaissance?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ChefEntrepriseSearchDto
     */
    registreNationalOrEmpty?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChefEntrepriseSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ChefEntrepriseSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ChefEntrepriseSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ChefEntrepriseSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ChefEntrepriseSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ChefEntrepriseSearchDto interface.
 */
export function instanceOfChefEntrepriseSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChefEntrepriseSearchDtoFromJSON(json: any): ChefEntrepriseSearchDto {
    return ChefEntrepriseSearchDtoFromJSONTyped(json, false);
}

export function ChefEntrepriseSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChefEntrepriseSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : UnaccentTextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : UnaccentTextSearchFromJSON(json['prenom']),
        'gsm': !exists(json, 'gsm') ? undefined : TextSearchFromJSON(json['gsm']),
        'telephone': !exists(json, 'telephone') ? undefined : TextSearchFromJSON(json['telephone']),
        'siegeSocial': !exists(json, 'siegeSocial') ? undefined : UnaccentTextSearchFromJSON(json['siegeSocial']),
        'lieuFormation': !exists(json, 'lieuFormation') ? undefined : UnaccentTextSearchFromJSON(json['lieuFormation']),
        'enseigneLieuFormation': !exists(json, 'enseigneLieuFormation') ? undefined : UnaccentTextSearchFromJSON(json['enseigneLieuFormation']),
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : DateSearchFromJSON(json['dateNaissance']),
        'registreNationalOrEmpty': !exists(json, 'registreNationalOrEmpty') ? undefined : TextSearchFromJSON(json['registreNationalOrEmpty']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ChefEntrepriseSearchDtoToJSON(value?: ChefEntrepriseSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': UnaccentTextSearchToJSON(value.nom),
        'prenom': UnaccentTextSearchToJSON(value.prenom),
        'gsm': TextSearchToJSON(value.gsm),
        'telephone': TextSearchToJSON(value.telephone),
        'siegeSocial': UnaccentTextSearchToJSON(value.siegeSocial),
        'lieuFormation': UnaccentTextSearchToJSON(value.lieuFormation),
        'enseigneLieuFormation': UnaccentTextSearchToJSON(value.enseigneLieuFormation),
        'dateNaissance': DateSearchToJSON(value.dateNaissance),
        'registreNationalOrEmpty': TextSearchToJSON(value.registreNationalOrEmpty),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

